





import Vue from "vue";
import { Component } from "vue-property-decorator";
declare var NODE_ENV:string //вебпак заменит на нужное значение при сборке

@Component
export default class AppComponent extends Vue {  
  constructor() {
    super();

  }
  errorCaptured(error: string) {
    this.$notification.error(error);
  }
  get isDevelopment(): boolean{
    return NODE_ENV==='development';
  }  
  created(){
           
  }

}
